<template>
  <div class="InfoAthletes">
    <div>
      <div class="alnCt ant-descriptions-title">
        <span style="color: #1890FF">▋</span>基本信息
      </div>
      <div class="alnCt mt20 descCont">
        <div class="avaCont">
          <a-avatar shape="square" :size="180" :src="info.headImageUrl"/>
        </div>
        <div class="flx1">
          <el-descriptions title="" :column="3" border>
            <el-descriptions-item label="姓名">{{ info.name || '-' }}</el-descriptions-item>
            <el-descriptions-item label="身高(cm)">{{ info.height || '-' }}</el-descriptions-item>
            <el-descriptions-item label="家庭地址">{{ info.addressName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="籍贯">{{ info.nativePlaceName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="体重(kg)">{{ info.weight || '-' }}</el-descriptions-item>
            <el-descriptions-item label="详细地址">{{ info.detailedAddress || '-' }}</el-descriptions-item>
            <el-descriptions-item label="性别">{{info.sex == 1 ? '男' : '女'}}</el-descriptions-item>
            <el-descriptions-item label="手机号码">{{ info.phone || '-' }}</el-descriptions-item>
            <el-descriptions-item label="所在机构">{{ info.employerName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="生日">{{ info.birthday || '-' }}</el-descriptions-item>
            <el-descriptions-item label="身份证号码">{{ info.idCardNo || '-' }}</el-descriptions-item>
            <el-descriptions-item label="入队时间">{{ info.workingTime || '-' }}</el-descriptions-item>
            <el-descriptions-item label="年龄">{{ info.age || '-' }}</el-descriptions-item>
            <el-descriptions-item label="邮箱">{{ info.email || '-' }}</el-descriptions-item>
            <el-descriptions-item label="训练项目">{{ info.trainingProject || '-' }}</el-descriptions-item>
            <el-descriptions-item label="职位">运动员</el-descriptions-item>
            <el-descriptions-item label="所属组别">{{info.teamName || '-'}}/{{info.groupName || '-'}}</el-descriptions-item>
            <el-descriptions-item label=" "></el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
    </div>
    <div class="mt20">
      <div class="alnCt ant-descriptions-title">
        <span style="color: #1890FF">▋</span>个人成绩
      </div>
      <el-descriptions title="" :column="1" border  class="otherDesc">
        <el-descriptions-item label="运动员等级">{{info.achieves && info.achieves.length > 0 ? info.achieves[0].sportsLevelName : '-'}}</el-descriptions-item>
        <el-descriptions-item label="运动成绩">{{info.achieves && info.achieves.length > 0 ? info.achieves[0].sportPerformance : '-'}}</el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="mt20">
      <div class="alnCt ant-descriptions-title">
        <span style="color: #1890FF">▋</span>其他信息
      </div>
      <el-descriptions title="" :column="1" border  class="otherDesc">
        <el-descriptions-item label="备注">{{info.remark || '无备注'}}</el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="mt20">
      <div class="alnCt ant-descriptions-title">
        <span style="color: #1890FF">▋</span>操作记录
      </div>
      <div class="wz-pl-2">
        <a-empty v-if="operatingList.length <= 0" :image="simpleImage" />
        <div class="mt15 card_records" v-for="(item, index) in operatingList" :key="index">
          <a-badge color="#108ee9" :text="item.dayTxt" />
          <div class="mt10">
            <el-card class="elCard_records">
              <div class="spcBt">
                <div>
                  <a-avatar size="large" :src="item.headImageUrl">
                    <template #icon>
                      <UserOutlined />
                    </template>
                  </a-avatar>
                  <span class="ml10">{{item.name}} <strong class="recordsText"><i>|</i>{{ item.operatingType }}</strong></span>
                </div>
                <div>{{item.timeTxt}}</div>
              </div>
            </el-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Empty } from "ant-design-vue";

export default {
  inject: ['getInfo', 'getOperatingList'],
  data() {
    return {
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
    };
  },
  computed: {
    info() {
      return this.getInfo();
    },
    operatingList() {
      return this.getOperatingList();
    }
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="less">
@import "/src/styles/common/common.less";
.InfoAthletes {
  ::v-deep .el-descriptions__body {
    width: 100%;
    background-color: unset;
  }
  ::v-deep .el-descriptions {
    display: flex;
    .el-descriptions-item {
      flex: 1;
    }
    .el-descriptions-row {
      th {
        height: 60px;
        width: 150px;
        color: #BCBCBC;
        font-size: 14px;
        font-weight: bold;
        background-color: #21284b;
      }
      td {
        height: 60px;
        min-width: 200px;
        color: #fff;
        font-size: 12px;
        background-color: #141937;
      }
    }
  }
}
:deep(.ant-descriptions-title){
  margin-top: 20px !important;
}
.descCont {
  position: relative;
  padding-left: 330px;
}
.avaCont {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 330px;
  height: 100%;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-right: none;
  background-color: #141937;
}
.recordsText{
  font-size:12px;
  margin-left:10px;
  color:#fff;
  font-weight:normal;
  i{
    margin-right:10px
  }
}
.elCard_records{
  border: 1px solid rgba(255, 255, 255, .1);
}


</style>